module.exports = __webpack_public_path__ + "static/01-7e21a88ca8a46b866b30158fef138ff2.jpg";